import * as AccordionPrimitive from '@radix-ui/react-accordion'
import { Typography } from '@cannect/new-components/atoms'
import { LuMinusCircle, LuPlusCircle } from 'react-icons/lu'
import { HOME_FAQ_ITEMS } from './constants'

/**
 * Seção de perguntas frequentes da home (Figma node 4161:23723).
 *
 * Duas colunas: título/apoio à esquerda (444px) e o acordeão à direita, com 98px entre elas.
 * Abaixo de `lg` as colunas empilham — o protótipo não tem versão mobile desta seção.
 *
 * Usa os primitivos do Radix em vez do átomo `Accordion`: aquele embute chevrons no Trigger e uma
 * borda fixa no Content que não é sobrescrevível, e o design pede ícones de +/− em círculo com a
 * linha divisória logo abaixo da pergunta (e não no rodapé do item).
 */
export const CommonQuestionsSection = () => (
  <section className="w-full bg-neutral-50">
    <div className="mx-auto flex w-full max-w-[1230px] flex-col gap-12 px-8 py-16 lg:flex-row lg:items-start lg:gap-[98px]">
      <div className="flex w-full flex-col gap-4 lg:w-[444px] lg:shrink-0">
        <p className="m-0 text-base leading-[1.6] text-neutral-800">Dúvidas frequentes</p>

        <div className="flex flex-col gap-8">
          <Typography.Heading
            level={2}
            type="headingTwo"
            weight="regular"
            className="m-0 leading-[49.28px] tracking-[-0.448px] text-neutral-800">
            {/* `span`, não `em`: o itálico é assinatura de marca, não ênfase semântica. */}
            Perguntas que todo <span className="italic">paciente faz</span>
          </Typography.Heading>

          <p className="m-0 text-sm leading-[1.4] text-neutral-800">
            Reunimos as perguntas mais comuns de quem está começando a explorar um caminho de cuidado com a Cannect.
          </p>
        </div>
      </div>

      <AccordionPrimitive.Root
        type="single"
        collapsible
        defaultValue="home-faq-0"
        className="flex w-full min-w-0 flex-col gap-8">
        {HOME_FAQ_ITEMS.map((item, index) => (
          <AccordionPrimitive.Item key={item.question} value={`home-faq-${index}`} className="w-full">
            <AccordionPrimitive.Header className="flex">
              <AccordionPrimitive.Trigger className="group flex w-full cursor-pointer appearance-none items-center justify-between gap-4 border-0 bg-transparent p-0 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-marketplace-800 focus-visible:ring-offset-2">
                <span className="text-sm font-semibold leading-[1.2] text-neutral-800">{item.question}</span>
                <LuMinusCircle className="hidden h-4 w-4 shrink-0 text-neutral-800 group-data-[state=open]:block" />
                <LuPlusCircle className="h-4 w-4 shrink-0 text-neutral-800 group-data-[state=open]:hidden" />
              </AccordionPrimitive.Trigger>
            </AccordionPrimitive.Header>

            {/* O design coloca a linha logo abaixo da pergunta; a resposta abre por baixo dela. */}
            <div aria-hidden className="mt-3 h-px w-full bg-neutral-100" />

            <AccordionPrimitive.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
              <p className="m-0 pt-6 text-xs leading-[1.4] text-neutral-800">{item.answer}</p>
            </AccordionPrimitive.Content>
          </AccordionPrimitive.Item>
        ))}
      </AccordionPrimitive.Root>
    </div>
  </section>
)
